function initNewsletterAndPasswordPopup() {
  const form = document.getElementById('newsletter-signup');
  const errorMessage = document.getElementById('error-message');
  const successMessage = document.getElementById('success-message');
  const emailInput = document.getElementById('email');

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const email = emailInput?.value;

      if (email && validateEmail(email)) {
        showSuccessMessage();
      } else {
        showErrorMessage();
      }
    });
  }

  function validateEmail(email) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  }

  function showSuccessMessage() {
    if (errorMessage) errorMessage.style.display = 'none';
    if (successMessage) successMessage.style.display = 'block';
  }

  function showErrorMessage() {
    if (successMessage) successMessage.style.display = 'none';
    if (errorMessage) errorMessage.style.display = 'block';
  }

  const openPopup = document.getElementById('open-password-popup');
  const closePopup = document.getElementById('closePasswordPopup');
  const backdrop = document.getElementById('passwordBackdrop');

  if (openPopup) {
    openPopup.addEventListener('click', function (e) {
      e.preventDefault();
      togglePasswordModalVisibility(true);
    });
  }

  if (closePopup) {
    closePopup.addEventListener('click', function () {
      togglePasswordModalVisibility(false);
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      togglePasswordModalVisibility(false);
    });
  }

  function togglePasswordModalVisibility(isVisible) {
    const passwordModal = document.getElementById('passwordModal');
    if (passwordModal) {
      passwordModal.classList.toggle('hidden', !isVisible);
    }
  }

  window.togglePasswordForm = function () {
    const passwordForm = document.getElementById('passwordForm');
    const defaultForm = document.querySelector('.default');

    if (passwordForm && defaultForm) {
      passwordForm.classList.toggle('hidden');
      defaultForm.classList.toggle('hidden');
      document.body.dataset.passwordMode =
        document.body.dataset.passwordMode === 'true' ? 'false' : 'true';
    }
  };
}

// Run on initial load
document.addEventListener('DOMContentLoaded', initNewsletterAndPasswordPopup);

// 🧩 Run when a section is loaded or reloaded inside Shopify Editor
document.addEventListener('shopify:section:load', initNewsletterAndPasswordPopup);
document.addEventListener('shopify:section:select', initNewsletterAndPasswordPopup);
document.addEventListener('shopify:section:deselect', initNewsletterAndPasswordPopup);
document.addEventListener('shopify:block:select', initNewsletterAndPasswordPopup);
document.addEventListener('shopify:block:deselect', initNewsletterAndPasswordPopup);
